import { Helpers } from '../../helpers';
import { IStackingStrategy } from '../../interfaces/istacking-strategy';
import { Well } from '../well';

export class StackingStrategyBase {
  StackingStrategyId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Wells_StackingStrategy?: Array<Well> | null;

  constructor(item?: IStackingStrategy) {
    if (item) {

      this.StackingStrategyId = item.StackingStrategyId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Wells_StackingStrategy = Helpers.createClassArray(Well, item.Wells_StackingStrategy);
    }
  }
}